<template>
<div class="spinner"></div>
</template>

<script>

export default {
  name: 'Spinner',

  props: {
  },

  data () {
    return {
      email: '',
      password: ''
    }
  }

}
</script>

<style>

@keyframes spin {
    from {transform:rotate(0deg)}
    to {transform:rotate(360deg)}
}

.spinner {
    width: 70px;
    height: 70px;
    animation-name: spin;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    border-radius:1000px;
    border-top: 8px solid #FE9B9B;
    border-left: 8px solid rgba(0,0,0,.05);
    border-right: 8px solid rgba(0,0,0,.05);
    border-bottom: 8px solid rgba(0,0,0,.05);
}
</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue